import React, { useEffect, useState } from 'react'
import Layout from "../../components/Layout/Layout";
import BackButton from '../../components/BackButton';
import Modal from '../../components/Modals/preonboard/modal';
import { HollowDotsSpinner } from 'react-epic-spinners';
import service from "../../services/complianceSheetServices"
import PreOnboardServices from '../../services/PreObnoard';
import { toast } from 'react-toastify';

const LogPnd = () => {

    const [open, setOpen] = useState("")
    const [accountNo, setAccountNo] = useState("")
    const [errMessage, setErrMessage] = useState("")
    const [AccountNoExist, setAccountNoExist] = useState("")
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({})
    const [complianceReason, setComplianceReason] = useState("")


    const submitForm =  async (e) => {
      e.preventDefault();
     setLoading(true)
      if(!complianceReason || complianceReason === ""){
        toast.warning("You must give a compliance reason")
        setErrMessage("You must give a compliance reason")
        setLoading(false)
        return
      }

      const reqBody = {
        "branchCode": data.branchCode,
        "accountName": data.customerName,
        "accountClass": data.accountClassCode,
        "isOnPnd": true,
        "accountNumber": accountNo,
        "complianceReason": complianceReason
      }

      const response = await service.createCompliancePnd(reqBody)
      if(response){
        setLoading(false)
        window.history.back();

      }
    }
    const openModal =  () => {
        setOpen(true)
    }
    const findUser =  async () => {
      const res = await PreOnboardServices.getAccount(accountNo);
     if(res){
      setData(res.data);
      setAccountNoExist(true)
     }
    }

  return (
    <Layout
    title="Log Pnd"
    pageTag={"compliance"}
    current={"/compliance/log"}
  >
     <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto">
              <BackButton />
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                      <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                        <div className="">
                          <div className="block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <form className="px-6">
                              <div className="mt-6 mb-12 flex items-center justify-between">
                                <div className="">
                                  <label
                                    htmlFor="firstname"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Account Number
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="accountNo"
                                      onChange={(e) =>
                                        setAccountNo(e.target.value)
                                      }
                                      value={accountNo}
                                      id="accountNo"
                                      autocomplete="given-name"
                                      placeholder="Enter Account Number"
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    
                                  </div>
                                </div>
                                <div className="flex gap-2 items-center">
                                  <button
                                    type="button"
                                    onClick={
                                      AccountNoExist ? openModal : findUser
                                    }
                                    className="btn-primary inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                  >
                                    {loading ? (
                                      <HollowDotsSpinner />
                                    ) : (
                                      <>
                                        {" "}
                                        {AccountNoExist
                                          ? "Log it"
                                          : "Find Account"}
                                      </>
                                    )}
                                  </button>
                                  {AccountNoExist && (
                                    <button
                                      type="button"
                                      onClick={() => setAccountNoExist(false)}
                                      className="btn-primary inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                    >
                                      Reset
                                    </button>
                                  )}
                                </div>
                              </div>
                              {AccountNoExist && (
                                <React.Fragment>
                                  <div className=" mt-5">
                                    <div className="d-flex flex-col">
                                      <h3>Personal Information</h3>
                                      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12"> 
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Account Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={data.customerName}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                               
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Bank Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={data.branchCode}
                                              defaultValue={data.branchCode}
                                             
                                              id="bankCode"
                                            autocomplete="given-name"
                                            
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                           Account Class
                                          </label>
                                          <div className="mt-1">
                                            <input
                                            disabled
                                              type="text"
                                              value={data.accountClassCode}
                                              
                                              name="accClass"
                                              id="accClass"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="surname"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Pnd Status
                                          </label>
                                          <div className="mt-1">
                                          <input
                                            disabled
                                              type="text"
                                              value={"True"}
                                              
                                              name="isOnPnd"
                                              id="accClass"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            
                                          </div>
                                        </div>
                                       
                                        <div className="">
                                          <label
                                            htmlFor="username"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                             Reason for Pnd
                                          </label>
                                          <div className="mt-1">
                                            <input
                                                onChange={(e) => setComplianceReason(e.target.value)}
                                              type="text"
                                              name="complianceReason"
                                              id="complianceReason"
                                              placeholder="Reason for pnd"
                                              value={complianceReason}
                                                
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                            
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {open && (
                <Modal
                  textField="to submit this account as pnd?"
                  action={submitForm}
                  setOpen={setOpen}
                  open={open}
                  loading={loading}
                  status={"Pnd"}
                  reason={complianceReason}
                  setReason={setComplianceReason}
                  errMessage={errMessage}
                  setErrMessage={setErrMessage}
                />
              )}
            </div>
          </main>
        </React.Fragment>
    </Layout>
  )
}

export default LogPnd
